import React, { Fragment } from "react";
import compressLongString from "@/app/utils/strings/compressLongString";
import { useTheme } from "next-themes";
import { ThirdWeb } from "./ThirdWeb";
import { ProfileIcon } from "../Icons";
import { usePathname } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { AUTH_MODE } from "@/app/enum/wallet";

type Props = {
  walletId: string | null | undefined;
  handleSignIn: () => void;
  loader: boolean;
  points: number;
  authMode: AUTH_MODE;
};

const ButtonSignIn = ({
  walletId,
  handleSignIn,
  loader,
  points,
  authMode,
}: Props) => {
  const t = useTranslations();
  const { theme } = useTheme();
  const pathname = usePathname()?.split("/");
  const isHomePage =
    pathname[1] === "" || (pathname[1] === "flights" && !pathname[2]);

  return (
    <button className="pe-0 ps-2">
      <span
        onClick={handleSignIn}
        className={`flex items-center gap-[4px] rounded-[999px] justify-center md:px-3 py-2 ${
          loader || walletId
            ? "md:px-6 xs:px-4 px-3"
            : `${
                isHomePage
                  ? "hover:bg-transparent bg-transparent transition dark:bg-sleap-gray-950 dark:hover:bg-sleap-gray-900"
                  : ""
              } `
        }`}
      >
        {/* ================= Custom Wallet ================= */}
        {authMode === AUTH_MODE.Custom && (
          <p
            className={`${
              walletId
                ? "font-base font-poppins text-base items-center gap-x-2"
                : "font-medium font-switzer xs:text-base text-sm"
            } ${
              isHomePage
                ? "md:text-lightwhite text-sleap-gray-950"
                : "md:text-lightwhite text-sleap-gray-950"
            } mb-0 sm:flex`}
          >
            {walletId && (
              <Fragment>
                <ProfileIcon
                  color={theme == "dark" ? "lightWhite" : "lightblack"}
                />
                <span className="flex flex-col items-center">
                  {`${compressLongString(walletId)}`}
                </span>
              </Fragment>
            )}

            {/* Loader dots */}

            <span
              className={`${
                walletId === undefined || loader ? "block" : "hidden"
              }`}
            >
              <span className="dots-container">
                <span className="dot !text-black"></span>
                <span className="dot !text-black"></span>
                <span className="dot !text-black"></span>
              </span>{" "}
            </span>

            {/* Sign-in text */}
            {!loader && !walletId && (
              <span className="!font-switzer !font-semibold">
                {t("Other.signIn")}
              </span>
            )}
          </p>
        )}

        {/* ================= ThirdWeb ================= */}
        {authMode === AUTH_MODE.Thirdweb && (
          <>
            <p
              className={`${
                walletId
                  ? "font-base font-poppins text-base"
                  : "font-medium font-switzer xs:text-sm text-xs"
              } ${
                isHomePage
                  ? "md:text-lightwhite text-sleap-gray-950"
                  : "md:text-lightwhite text-sleap-gray-950"
              } mb-0 sm:flex hidden`}
            >
              <ThirdWeb
                walletId={walletId}
                theme={theme ?? ""}
                label={t("Other.signIn")}
                className={`!min-w-5 !text-base ${
                  isHomePage
                    ? "md:text-lightwhite text-sleap-gray-950"
                    : "md:text-lightwhite text-sleap-gray-950"
                } !font-switzer !font-semibold flex justify-center items-center px-0`}
              />
            </p>

            <p
              className={`${
                walletId
                  ? "font-base font-poppins text-base"
                  : "font-medium font-switzer xs:text-sm text-xs"
              } ${
                isHomePage
                  ? "md:text-lightwhite text-sleap-gray-950"
                  : "md:text-lightwhite text-sleap-gray-950"
              } mb-0 sm:hidden block`}
            >
              <ThirdWeb
                walletId={walletId}
                theme={theme ?? ""}
                label={t("Other.signIn")}
                className={`!min-w-5 !text-base ${
                  isHomePage
                    ? "md:text-lightwhite text-sleap-gray-950"
                    : "md:text-lightwhite text-sleap-gray-950"
                } !font-switzer !font-semibold flex justify-center items-center ${
                  !walletId ? "!px-3 h-8" : ""
                }`}
              />
            </p>
          </>
        )}
      </span>
    </button>
  );
};

export default ButtonSignIn;
